import Vue from '@/index.js'

import page from '@/mixins/page'
import './main.scss'

import layoutCategoryPage from '@/components/layout/category/layout-category-page'
import Loader from '@/components/layout/layout-loader'
//
import uiFilterRange from '@/components/ui/ui-filter/ui-filter-range'
import uiFilterSelect from '@/components/ui/ui-filter/ui-filter-select'
import uiFilterCheckbox from '@/components/ui/ui-filter/ui-filter-checkbox'

export default new Vue({
  el: '#app',
  components: { layoutCategoryPage, Loader, uiFilterRange, uiFilterSelect, uiFilterCheckbox },
  mixins: [page],
})
